"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LoadingLine = void 0;

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _Spinner = require("@fluentui/react/lib/Spinner");

var React = _interopRequireWildcard(require("react"));

var _LineAligned = require("../LineAligned/LineAligned");

var _stylingConstants = require("../styling/stylingConstants");

var getClassNames = (0, _react.classNamesFunction)();

var LoadingLineBase = function LoadingLineBase(_ref) {
  var className = _ref.className,
      _ref$spinnerSize = _ref.spinnerSize,
      spinnerSize = _ref$spinnerSize === void 0 ? _Spinner.SpinnerSize.medium : _ref$spinnerSize,
      styles = _ref.styles,
      children = _ref.children;
  var classes = getClassNames(styles, {});
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _react.css)('ms-LoadingLine', className, classes.root),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LineAligned.LineAligned, {
      styles: classes.subComponentStyles.lineAligned,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Spinner.Spinner, {
        size: spinnerSize,
        styles: classes.subComponentStyles.spinner
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _react.css)('ms-LoadingLine--message', classes.message),
      children: children
    })]
  });
};

var LoadingLine = (0, _react.styled)(LoadingLineBase, {
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    minWidth: 0,
    margin: "".concat(_stylingConstants.gridUnit * 3, "px 0")
  },
  message: {
    flex: '1 1 auto',
    minWidth: 0
  },
  subComponentStyles: {
    lineAligned: {
      root: {
        paddingRight: '0.5em'
      }
    },
    spinner: {
      root: {
        margin: "-50% 0"
      }
    }
  }
});
exports.LoadingLine = LoadingLine;